module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_5_2-13de4bfb93ac6f9bf2221e02c46b6898.webp";